import * as React from "react";
import type { SVGProps } from "react";
const SvgIconAlertCircleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8M8 3.57c.47 0 .86.39.86.86v3.71c0 .48-.39.86-.86.86s-.86-.38-.86-.86V4.43c0-.47.39-.86.86-.86m1.14 7.72c0 .63-.5 1.14-1.14 1.14s-1.14-.51-1.14-1.14c0-.64.5-1.15 1.14-1.15s1.14.51 1.14 1.15"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconAlertCircleFilled;
